import { render, staticRenderFns } from "./fzadmin.vue?vue&type=template&id=6bd158bc"
import script from "./fzadmin.vue?vue&type=script&lang=js"
export * from "./fzadmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports